var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAcSuccessCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 21.9,
    height: 16.2,
    viewBox: "0 0 21.9 16.2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M20.9333 0.972675C21.2246 1.26722 21.2219 1.74208 20.9273 2.03332L7.57733 15.2333C7.2868 15.5206 6.81981 15.5225 6.52699 15.2375L0.976985 9.83754C0.680107 9.54869 0.673603 9.07386 0.962456 8.77698C1.25131 8.48011 1.72614 8.4736 2.02302 8.76246L7.04577 13.6495L19.8727 0.966682C20.1672 0.675449 20.6421 0.678131 20.9333 0.972675Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcSuccessCheck);
export default __webpack_public_path__ + "static/media/ac-success-check.75404e3c4b30249ab4bf31bc2d171e1c.svg";
export { ForwardRef as ReactComponent };